import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { translateConfig } from './classes/translate-config'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'

@NgModule({ declarations: [], imports: [CommonModule,
        TranslateModule.forRoot(translateConfig)], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppTranslateModule {}
